function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.39415 11.6308L7.38436 18.8823C7.30264 19.4692 7.70266 20 8.22664 20H11.3471C11.8711 20 12.2711 19.4692 12.1894 18.8823L11.1796 11.6308C11.1141 11.1609 10.7569 10.8147 10.3373 10.8147H9.23643C8.81683 10.8147 8.45959 11.1609 8.39415 11.6308Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.78686 5.01351L7.36576 7.41558C6.90078 7.87691 6.17094 7.64187 5.98924 6.97228L4.77106 2.48316C4.70657 2.2455 4.7253 1.98881 4.82337 1.76642L5.33262 0.611559C5.61611 -0.0313138 6.39715 -0.111168 6.77748 0.463835L9.78686 5.01351L13.2157 0.347999C13.6094 -0.187651 14.3585 -0.0890722 14.6335 0.534576L15.1613 1.73146C15.2684 1.97446 15.2805 2.25737 15.1945 2.51094L13.6361 7.1052C13.4233 7.73256 12.7248 7.92838 12.2787 7.48576L9.78686 5.01351Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.33198 9.03438L3.98667 3.31408C3.88713 2.89083 3.54907 2.59634 3.16275 2.59634H2.5388C1.59692 2.59634 0.833374 3.4621 0.833374 4.53008V17.5828C0.833374 18.6508 1.59692 19.5166 2.5388 19.5166H5.22101C5.64061 19.5166 5.99785 19.1704 6.06329 18.7005L7.1886 10.6194C7.2147 10.432 7.1885 10.2401 7.11369 10.0704L7.07327 9.97876C6.91782 9.62626 6.55744 9.457 6.2277 9.58163C5.84583 9.72596 5.4357 9.47538 5.33198 9.03438Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2788 9.07118L15.9879 3.25746C16.1039 2.86264 16.4298 2.59634 16.7968 2.59634H17.4613C18.4032 2.59634 19.1667 3.4621 19.1667 4.53008V17.5828C19.1667 18.6508 18.4032 19.5166 17.4613 19.5166H14.3527C13.9331 19.5166 13.5759 19.1704 13.5104 18.7005L12.3851 10.6194C12.359 10.432 12.3852 10.2401 12.46 10.0704L12.4913 9.99952C12.652 9.63511 13.0246 9.46013 13.3654 9.58897C13.7437 9.73195 14.1527 9.50013 14.2788 9.07118Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.1839 7.1475L8.09518 8.38197C7.6971 8.83335 7.85712 9.60194 8.3912 9.8038C8.46842 9.83298 8.54929 9.84786 8.63069 9.84786H10.943C11.0244 9.84786 11.1053 9.83298 11.1825 9.8038C11.7166 9.60194 11.8766 8.83334 11.4785 8.38197L10.3898 7.1475C10.0568 6.76991 9.51691 6.76991 9.1839 7.1475Z",
  fill: "white"
});

function SvgNewClientIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewClientIcon);
export default __webpack_public_path__ + "static/media/NewClientIcon.62b11d98.svg";
export { ForwardRef as ReactComponent };